import type { ReactNode } from 'react';
import { useState } from 'react';
import {
  Button,
  Dialog,
  Inline,
  Text,
  LinkButton,
  breakpoints,
  dialogWidths,
  textVariants,
} from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { analytics } from '@eti/utils';

interface BrandedFareV2Props {
  brandedFareName: string;
  children: ReactNode;
}
const BrandedFareV2 = ({ brandedFareName, children }: BrandedFareV2Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  analytics.useLogMouseFlowTagEffect('Branded fare details', isOpen);
  return (
    <>
      <Inline data-testid="branded-fare-v2" spacing={8}>
        <Text asHtml variant={textVariants._16}>
          {t('PaymentPage.BrandedFare.FareNameMessage.Text', brandedFareName)}
        </Text>
        <LinkButton
          data-testid="branded-fare-v2-popup-link"
          onClick={() => {
            setIsOpen(true);
          }}
        >
          {t('PaymentPage.BrandedFare.PopupLink.Label')}
        </LinkButton>
      </Inline>
      <Dialog
        closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
        data-testid="branded-fare-v2-popup"
        desktopWidth={dialogWidths._568}
        footer={
          <Inline align="end" collapseBelow={breakpoints._560} spacing={8}>
            <Button onClick={() => setIsOpen(false)} variant="primary">
              {t('PaymentPage.BrandedFare.PopupCloseButton.Label')}
            </Button>
          </Inline>
        }
        isOpen={isOpen}
        onDismiss={() => {
          setIsOpen(false);
        }}
        title={brandedFareName}
      >
        {children}
      </Dialog>
    </>
  );
};

export default BrandedFareV2;
